import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, SITE } from "@/data/content";
import { scrollToHash } from "@/utils/scroll";

const AnchorLink = ({ link, className, testId, onClick }) => (
  <a
    href={link.hash}
    data-testid={testId}
    className={className}
    onClick={(e) => {
      e.preventDefault();
      scrollToHash(link.hash);
      onClick?.();
    }}
  >
    {link.label}
  </a>
);

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-slate-100 bg-white/95 backdrop-blur-sm">
      <div
        data-testid="legacy-banner"
        className="flex h-10 w-full items-center justify-center bg-navy px-6 md:px-12"
      >
        <p className="banner-text text-[13px] font-bold tracking-[0.3px] text-white md:text-[15px]">
          Every product, every patent, every fix — Pratt's work now lives on
          through <span className="banner-accent">Groundworks</span>.
        </p>
      </div>
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-6 md:h-20 md:px-12">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => {
            e.preventDefault();
            scrollToHash("#top");
          }}
          className="font-display text-xl font-bold uppercase tracking-tight text-ink"
        >
          {SITE.name}
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <AnchorLink
              key={link.hash}
              link={link}
              testId={`nav-link-${link.label.toLowerCase()}`}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-navy"
            />
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-menu-toggle"
            className="text-ink md:hidden"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="border-t border-slate-100 bg-white px-6 py-4 md:hidden"
          aria-label="Mobile"
        >
          {NAV_LINKS.map((link) => (
            <AnchorLink
              key={link.hash}
              link={link}
              onClick={() => setOpen(false)}
              className="block py-3 font-display text-lg font-semibold uppercase tracking-wide text-ink"
            />
          ))}
        </nav>
      )}
    </header>
  );
};
